import { Asset, Token } from "../assets/types";

// // // //

// QUESTION - are any of these fields nullable?
export interface Transaction {
    id: string;
    timestamp: string;
    date: string;
    transaction_hash: string;
    amount: number;
    usd_amount: number;
    to_address: string;
    from_address: string;
    asset: Asset;
    token: Token;
    transaction_type: {
        id: number;
        slug: string;
        name: string;
        description: string | null;
        icon_url: string | null;
        documentation_url: string | null;
    };
}

export enum TransactionColumns {
    id = "id",
    timestamp = "timestamp",
    date = "date",
    transactionHash = "transaction_hash",
    amount = "amount",
    usdAmount = "usd_amount",
    toAddress = "to_address",
    fromAddress = "from_address",
    // // // //
    // Foreign Key fields
    assetID = "asset_id",
    tokenID = "token_id",
    assetClassID = "asset_class_id",
    protocolID = "protocol_id",
    networkID = "network_id",
    transactionTypeID = "transaction_type_id",
}
